import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const getJobDetail = (uuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('job/' + uuid)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const saveJobActivity = (jobActivity) => {
  return getItem('token').then(token => {
    return HTTP(token).put('job/activity', jobActivity)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const saveJobApplication = (jobApplication) => {
  return getItem('token').then(token => {
    return HTTP(token).put('job/application', jobApplication)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const updateJobApplicationUserStatus = (applicationId, status) => {
  return getItem('token').then(token => {
    return HTTP(token).put('job/' + applicationId + '/status/' + status)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const loadJobApplication = (jobId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('job/' + jobId + '/user/application')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const loadJobApplications = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('job/user/all/application')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getAllEntityIdsWithRecommendation = (entityType) => {
  return getItem('token').then(token => {
    return HTTP(token).get('recommendation/all/entity/' + entityType)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getRecommendationForEntity = (entityUuid) => {
  return getItem('token').then(token => {
    return HTTP(token).get('recommendation/entity/' + entityUuid)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLibraryPositionMapping = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('configuration/library_position_mapping')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/job/api.js